const THIRD_PARTY_SERVICE = '3rd Party Service';
const CUSTOM = 'Custom';
const CUSTOM_LEASE = 'Custom Lease';
const CUSTOMER_OWNED_BANK_FINANCED = 'Customer Owned - Bank Financed';
const CUSTOMER_OWNED_FULL_UPFRONT = 'Customer Owned - Full Upfront';
const LEASE_POWER_PLAN = 'Lease Power Plan';
const LOW_UPFRONT = 'Low Upfront';
const MONITORING_ONLY = 'Monitoring Only';
const PPA_GOLDEN_TICKET = 'PPA Golden Ticket';
const PPA_POWER_PLAN = 'PPA Power Plan';
const PREPAID = 'Prepaid';
const PREPAID_LEASE = 'Prepaid Lease';
const SUNRUN_2007_HOLIDAY_PROMO = 'Sun Run 2007 Holiday Promo';
const SUNRUN_AKEENA_LIVERMORE_PROMO_08 = "SunRun-Akeena Livermore Promo '08";
const SUNRUN_DECREASING_PACKAGE = 'Sun Run Decreasing Package';
const SUNRUN_LEASE = 'Sun Run Lease';
const SUNRUN_POWER_PLAN = 'SunRun Power Plan';
const SUNRUN_REC_AVALON_PROMO_08 = "SunRun-REC Avalon Promo '08";
const SUNRUN_REC_CAMBRIAN_SJ_PROMO_08 = "SunRun-REC Cambrian SJ Promo '08";
const SUNRUN_REC_CUPERTINO_DISCOUNT_PROGRAM_08 = "SunRun-REC Cupertino Discount Program '08";
const SUNRUN_REC_DOWNTOWN_SAN_JOSE_PROMO_07_08 = "Sun Run-REC Downtown San Jose Promo '07-'08";
const SUNRUN_REC_LIVERMORE_PROMO_08 = "SunRun-REC Livermore Promo '08";
const SUNRUN_REC_MONTEREY_DISCOUNT_PROGRAM_08 = "SunRun - REC Monterey Discount Program '08";
const SUNRUN_REC_SANTA_YNEZ_COMMUNITY_PROGRAM = 'SunRun-REC Santa Ynez Community Program';
const SUNRUN_REC_WALNUT_CREEK_DISCOUNT_PROGRAM_08 = "SunRun - REC Walnut Creek Discount Program '08";
const SUNRUN_SERVICE_FLAT_RATE = 'Sun Run Service (Flat-Rate)';
const SUNRUN_SERVICE_PARTIAL_PREPAY = 'Sun Run Service + Partial Pre-Pay';
const SUNRUN_SERVICE_PREPAY = 'Sun Run Service + Pre-pay';
const SUNRUN_TOTAL_SOLAR = 'SunRun Total Solar';
const SUNRUN_TOTAL_SOLAR_PREPAID_LEASE = 'SunRun Total Solar Prepaid Lease';
const SUNRUN_TOTAL_SOLAR_SREC = 'SunRun Total Solar SREC';
const SUNRUN_VALUE_PLAN_GOLDEN_TICKET = 'SunRun Value Plan (i.e. Golden Ticket)';
const TOTAL_SOLAR = 'Total Solar';
const TOTAL_SOLAR_CUSTOM = 'Total Solar Custom';
const TOTAL_SOLAR_CUSTOM_LEASE = 'Total Solar Custom Lease';
const TOTAL_SOLAR_CUSTOM_PPA = 'Total Solar Custom PPA';
const TOTAL_SOLAR_LOW_UPFRONT = 'Total Solar Low Upfront';
const TOTAL_SOLAR_LOW_UPFRONT_LEASE = 'Total Solar Low Upfront Lease';
const TOTAL_SOLAR_LOW_UPFRONT_PPA = 'Total Solar Low Upfront PPA';
const TOTAL_SOLAR_PREPAID = 'Total Solar Prepaid';
const TOTAL_SOLAR_PREPAID_LEASE = 'Total Solar Prepaid Lease';
const TOTAL_SOLAR_PREPAID_PPA = 'Total Solar Prepaid PPA';
const TOTAL_SOLAR_PREPAID_PPA_SREC = 'Total Solar Prepaid PPA SREC';
const TOTAL_SOLAR_SREC = 'Total Solar SREC';

export {
  THIRD_PARTY_SERVICE,
  CUSTOM,
  CUSTOM_LEASE,
  CUSTOMER_OWNED_BANK_FINANCED,
  CUSTOMER_OWNED_FULL_UPFRONT,
  LEASE_POWER_PLAN,
  LOW_UPFRONT,
  MONITORING_ONLY,
  PPA_GOLDEN_TICKET,
  PPA_POWER_PLAN,
  PREPAID,
  PREPAID_LEASE,
  SUNRUN_2007_HOLIDAY_PROMO,
  SUNRUN_AKEENA_LIVERMORE_PROMO_08,
  SUNRUN_DECREASING_PACKAGE,
  SUNRUN_LEASE,
  SUNRUN_POWER_PLAN,
  SUNRUN_REC_AVALON_PROMO_08,
  SUNRUN_REC_CAMBRIAN_SJ_PROMO_08,
  SUNRUN_REC_CUPERTINO_DISCOUNT_PROGRAM_08,
  SUNRUN_REC_DOWNTOWN_SAN_JOSE_PROMO_07_08,
  SUNRUN_REC_LIVERMORE_PROMO_08,
  SUNRUN_REC_MONTEREY_DISCOUNT_PROGRAM_08,
  SUNRUN_REC_SANTA_YNEZ_COMMUNITY_PROGRAM,
  SUNRUN_REC_WALNUT_CREEK_DISCOUNT_PROGRAM_08,
  SUNRUN_SERVICE_FLAT_RATE,
  SUNRUN_SERVICE_PARTIAL_PREPAY,
  SUNRUN_SERVICE_PREPAY,
  SUNRUN_TOTAL_SOLAR,
  SUNRUN_TOTAL_SOLAR_PREPAID_LEASE,
  SUNRUN_TOTAL_SOLAR_SREC,
  SUNRUN_VALUE_PLAN_GOLDEN_TICKET,
  TOTAL_SOLAR,
  TOTAL_SOLAR_CUSTOM,
  TOTAL_SOLAR_CUSTOM_LEASE,
  TOTAL_SOLAR_CUSTOM_PPA,
  TOTAL_SOLAR_LOW_UPFRONT,
  TOTAL_SOLAR_LOW_UPFRONT_LEASE,
  TOTAL_SOLAR_LOW_UPFRONT_PPA,
  TOTAL_SOLAR_PREPAID,
  TOTAL_SOLAR_PREPAID_LEASE,
  TOTAL_SOLAR_PREPAID_PPA,
  TOTAL_SOLAR_PREPAID_PPA_SREC,
  TOTAL_SOLAR_SREC,
};
